import { requestTypeTextColor } from "components/Card/RequestCard";
import useText from "constants/text";
import { ERequestType, EVehiculeType, Vehicles, Vehicle_Type } from "generated/graphql";
import { ContainerElements, HeaderContainerElements, RequestTypeTitle, TitleSecondary } from "../MainStyles";

interface IHeaderRequestDetails {
  request: any;
  type: ERequestType;
  vehicleType?: Vehicle_Type;
}

export default function HeaderRequestDetails({ request, type }: IHeaderRequestDetails) {
  const { text } = useText();

  const renderNumberOfVehicles = (vehicles: Vehicles[]) => {
    const count = vehicles.reduce((prev, next) => prev + next?.numberOfVehicule, 0);
    return count;
  };
  const vehicleDescription = (type?: EVehiculeType) => {
    switch (type) {
      case EVehiculeType.Scooter:
        return text.requestQuote.desc_vehicle_1;
      case EVehiculeType.MiniVan:
        return text.requestQuote.desc_vehicle_2;
      case EVehiculeType.Van:
        return text.requestQuote.desc_vehicle_3;
      default:
        return text.requestQuote.desc_vehicle_4;
    }
  };

  return (
    <>
      <ContainerElements>
        <HeaderContainerElements>
          <RequestTypeTitle color={requestTypeTextColor[type]}>
            {" "}
            {vehicleDescription(request?.vehicles[request?.vehicles.length - 1]?.vehicleType)}
          </RequestTypeTitle>
          {request?.vehicles?.length && (
            <TitleSecondary color="#fff">{renderNumberOfVehicles(request?.vehicles as Vehicles[])}</TitleSecondary>
          )}
        </HeaderContainerElements>
      </ContainerElements>
    </>
  );
}
